import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { EditorComponent, EditorModule } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { ApiService } from '../../../services/api.service';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from '../../../shared/shared.module';
import { UploadModule } from '../../../modal/upload/upload.module';
import { UploadDocumentComponent } from '../../../components/upload-document/upload-document.component';
import { forkJoin, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  selector: 'app-idex-from',
  imports: [CommonModule, FormsModule, ReactiveFormsModule,DropdownModule,SharedModule,EditorModule,UploadModule,ToastModule],
  providers: [MessageService],
  templateUrl: './idex-from.component.html'
})
export class IdexFromComponent implements OnInit{
  @Input() url: string = '';
  @Input() title: string = 'Create New Challenge';
  @Input() isViewOnly: boolean = false; 
  @Input() stepDetails: any;
  @Input() subScheme: any;
  @Input() challengesData:any;
  @Output() submitProposal = new EventEmitter<any>();
  @Input() categoryFormVisible: any = {
    
    name: true,
    scheme: true,
    organisation: true,
    category: true,
    challenge_brief: true,
    prototype_development: true,
    release_date: true,
    nodal_officer_id: true,
    nodal_precurement: true,
    technology_domain: true,
    problem_statement: true,
    coordinated_agency_id: true,
    requirement: true,
    ip_value: true,
    functional_advantages: true,
    domestic: true,
    substitution: true,
    preliminary_scope: true,
    competitive_solution: true,
    potential_market: true,
    risk_assessment: true,
    mpo_qty: true,
    proposal_id: true,
    lunch_version:true,
  }
  draftProposals: any[] = [];
  isSectionOpen: any = {
    createNewProposal: true,
    basicInfo: false,
    documentUploads: false,
    draftProposals: false,
  };
  selectedDraftProposal: any;
  init: EditorComponent['init'] = init;
  selectedDmsFiles: any[] = [];
  @ViewChild('uploadDoc') uploadDocumentComponent!: UploadDocumentComponent;
  technologyDomainOptions:any[] = [];
  payload: any = {};
  categoryOptions = [
    { label: 'To Move', value: 'To Move' },
    { label: 'To Fight', value: 'To Fight' },
    { label: 'To Float', value: 'To Float' },
  ];

  challengeForm: FormGroup = new FormGroup({
    id: new FormControl(null),
    name: new FormControl('', Validators.required),
    scheme: new FormControl(null, Validators.required),
    organisation: new FormControl(null, Validators.required),
    category: new FormControl('', Validators.required),
    challenge_brief: new FormControl('', Validators.required),
    prototype_development: new FormControl('', Validators.required),
    nodal_officer_id: new FormControl(null, Validators.required),
    nodal_precurement: new FormControl(null, Validators.required),
    technology_domain: new FormControl('', Validators.required ),
    problem_statement: new FormControl('', Validators.required),
    coordinated_agency_id: new FormControl(null, Validators.required),
    requirement: new FormControl('', Validators.required),
    ip_value: new FormControl(''),
    release_date: new FormControl(''),
    functional_advantages: new FormControl('',),
    domestic: new FormControl(''),
    substitution: new FormControl(''),
    preliminary_scope: new FormControl(''),
    competitive_solution: new FormControl(''),
    potential_market: new FormControl(''),
    risk_assessment: new FormControl('', Validators.required),
    mpo_qty: new FormControl('',Validators.required),
    proposal_id: new FormControl(null),
    launch_version: new FormControl(''),

  });


  idexfristStepData:any;
  userList=[];  unitList=[] ;schemes=[]
  readonly requiredValidator = Validators.required;
  draftProposalColumns: any[] = [
    { field: 'proposal_name', header: 'Name', filterType: 'text' },
    { field: 'modified_on', header: 'Last Update', filterType: 'text' },
  ]
  constructor(private apiService: ApiService, private fb: FormBuilder,private route: ActivatedRoute, private messageService: MessageService) {}

  ngOnInit(): void {
     console.log(this.challengesData,'challengesData');
    this.challengeForm.get('scheme')?.value !== 7 ? this.apiCall() : '';
   this.stepDetails ? this.onStepCall() : this.onCreatingTine();
  }
  onStepCall(){
    this.challengeForm.get('scheme')?.patchValue(this.challengesData?.scheme_id || this.stepDetails?.step_mapping?.scheme?.id);
    if(this.stepDetails) {
      if( this.stepDetails?.can_edit){
        this.challengeForm.enable();
      } else {
        this.rebuildEditor()
        this.challengeForm.disable();
      }
    }
    if(this.challengesData){
      this.populateDraftProposal(this.challengesData);
      return;
    }
    this.apiService.getAPI(this.url+`?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
      let data:any;
      switch(this.stepDetails.code){
        case 'idex_001':
          data = res[0];
          this.populateDraftProposal(data);
          break;
        case 'U-PC':
          data = res[0];
          
          this.populateDraftProposal(data);
          break;
        default:
          data = res.challenge;
          this.populateDraftProposal(data);
          break;
      }
    });
  }

  
  onCreatingTine(){
    this.getDraftProposals();
    this.challengeForm.get('scheme')?.patchValue(this.subScheme?.id);
    this.route.queryParams.subscribe((params: any) => {
      const schemeId = params['scheme_id'];
      this.payload.scheme_id = schemeId;
    });
    this.getPushFiles();
  }

  rebuildEditor() {
    this.init = {
      ...this.init,
      readonly: false
    };
    
  }
  getDraftProposals(id?:number) {
    this.apiService.getAPI('/idex/save-draft/proposal/?scheme_id='+this.subScheme?.id).subscribe((res: any) => {
      this.draftProposals = res;
      if(id){
         this.selectedDraftProposal = this.draftProposals.find((draft: any) => draft.proposal_id === id);
         this.populateDraftProposal(this.selectedDraftProposal);
      }
    });
  }
  onDocumentUpload(data: any) {
    // Automatically set name to PDS or PRU if not already set
    // if (data && data.name) {
    //   const currentName = (data.name || '').toUpperCase().trim();
    //   // Check if we already have PDS or PRU
    //   const hasPDS = this.selectedDmsFiles.some((f: any) => (f.name || '').toUpperCase().trim() === 'PDS');
    //   const hasPRU = this.selectedDmsFiles.some((f: any) => (f.name || '').toUpperCase().trim() === 'PRU');
      
    //   // If name is not PDS or PRU, assign automatically
    //   if (currentName !== 'PDS' && currentName !== 'PRU') {
    //     if (!hasPDS) {
    //       data.name = 'PDS';
    //     } else if (!hasPRU) {
    //       data.name = 'PRU';
    //     } else {
    //       // Both already exist, keep original name
    //     }
    //   }
    // }
    
    this.selectedDmsFiles.push(data); 
  }

  populateDraftProposal(draft: any) {
    this.selectedDmsFiles=[]
    this.messageService.add({ severity: 'info', summary: 'Draft proposal populated successfully.' });
    this.selectedDraftProposal = draft;
   
      this.challengeForm.patchValue({...draft, name: draft?.title, coordinated_agency_id: draft.coordinated_agency,scheme: draft.scheme_id});
      draft.coordinated_agency ? this.onUnitChange({value: draft.coordinated_agency}) : '';
      
    
  }

  onUnitChange(event: any) {
    this.apiService.getAPI(`/account/users/?unit=${event.value}`).subscribe((res: any) => {
      this.userList = res.data;
      this.challengeForm.get('coordinated_agency_id').value ? this.challengeForm.get('nodal_officer_id')?.patchValue(this.userList.find(user => user.id === this.selectedDraftProposal.nodal_officer)) :'';
      console.log(this.challengeForm.value,'challengeForm.value',this.userList.find(user => user.id === this.selectedDraftProposal.nodal_officer));
    });
  }

  apiCall() {
    forkJoin([
      this.apiService.getAPI(`/master/units/`),
      this.apiService.getAPI(`/master/technology-domain/`),
      this.apiService.getAPI(`/master/scheme/sub/details/?id=${this.payload.scheme_id || 46}`),
      this.stepDetails?.proposal || this.challengesData?.proposal_id
        ? this.apiService.getAPI(`/transaction/copy/proposals/${this.stepDetails?.proposal || this.challengesData?.proposal_id}/steps/?code=idex_001`)
        : of([]),
    ]).subscribe(([unitRes, techDomainRes, schemeRes, idexFirstStepRes]) => {
      this.unitList = unitRes.data ?? unitRes;
      this.schemes = (schemeRes.data ?? schemeRes)[0]?.sub_scheme;
      this.idexfristStepData = (idexFirstStepRes.data ?? idexFirstStepRes)[0];
      this.technologyDomainOptions = techDomainRes.data ?? techDomainRes;
    });
  }
  

  submitForm() {
    // Save Draft - No validation required, allow saving without PDS/PRU or mandatory fields
    let payload: any;

     payload={
      proposal: {
        name: this.challengeForm.get('name')?.value,
        scheme: this.challengeForm.get('scheme')?.value,
        proposal_id: this.challengeForm.get('proposal_id')?.value,
    },
    challenge:{
      ...this.challengeForm?.value,
      title: this.challengeForm.get('name')?.value,
      nodal_officer_id: this.challengeForm.get('nodal_officer_id')?.value?.id,
      release_date: this.challengeForm.get('release_date')?.value,
    },
    action: this.challengeForm.get('proposal_id')?.value ? 'update' : 'create'
  }

  this.challengeForm.get('id')?.value ? payload.challenge.challenge_id = this.challengeForm.get('id')?.value : '';
  delete payload.challenge.proposal_id;
  delete payload.challenge.scheme;
  delete payload.challenge.name;

  const fd = new FormData();
  fd.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
  const meta: any[] = [];
  (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
    if (!it?.file) return;
    const name = it.name || `file_${i + 1}`;
    fd.append('files', it.file, name);
    meta.push({ id: it?.id , name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
  });
  fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));

  this.apiService.postAPI('/idex/save-draft/proposal/', fd).subscribe(
    (res: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Draft saved successfully.' });
      this.getDraftProposals(res.proposal_id);
    },
    (err: any) => this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error || 'Failed to save draft.' })
  );
  console.log(payload);
}


async finalSubmit() {
  // Validate mandatory form fields first
  if (!this.challengeForm.valid) {
    this.messageService.add({ 
      severity: 'error', 
      summary: 'Validation Error', 
      detail: 'Please fill all mandatory fields before submitting.' 
    });
    return;
  }
  
  // Validate PDS and PRU files are uploaded
  let filesToCheck: any[] = [];
  
  if (this.uploadDocumentComponent && this.uploadDocumentComponent['documentsArray']) {
    // Get ALL files from upload component's form array (including PDS, PRU, and any other files)
    filesToCheck = this.uploadDocumentComponent['documentsArray'].controls
      .map((control: any) => control.value)
      .filter((val: any) => val && val.name);
  } else {
    // Fallback to selectedDmsFiles if upload component not available
    filesToCheck = [...this.selectedDmsFiles];
  }
  
  // Find PDS and PRU files specifically (other files are allowed but not required)
  let pdsFile: any = null;
  let pruFile: any = null;
  
  filesToCheck.forEach((file: any) => {
    const fileName = (file.name || '').toUpperCase().trim();
    const hasFile = file.file && (file.file instanceof File || file.file?.name || file.file || typeof file.file === 'string');
    
    if (fileName === 'PDS' && hasFile) {
      // Keep the first valid PDS file found
      if (!pdsFile) {
        pdsFile = file;
      }
    } else if (fileName === 'PRU' && hasFile) {
      // Keep the first valid PRU file found
      if (!pruFile) {
        pruFile = file;
      }
    }
  });
  
  // Validate that both PDS and PRU are uploaded with files attached
  // Other files with different names are allowed and don't need validation
  if((!pdsFile || !pruFile) && !this.selectedDraftProposal) {
    const missingFiles = [];
    if (!pdsFile) missingFiles.push('PDS');
    if (!pruFile) missingFiles.push('PRU');
    
    this.messageService.add({ 
      severity: 'error', 
      summary: 'Error', 
      detail: `Please upload both PDS and PRU documents with files attached. Missing: ${missingFiles.join(' and ')}.` 
    });
    return;
  }
 const payload={
  proposal: {
      name: this.challengeForm.get('name')?.value,
      scheme: this.challengeForm.get('scheme')?.value,
  },
  challenge:{
    ...this.challengeForm?.value,
    title: this.challengeForm.get('name')?.value,
    nodal_officer_id:  this.challengeForm.get('nodal_officer_id')?.value?.id,
  },
  route_conf:''
}

delete payload.challenge.proposal_id;
delete payload.challenge.scheme;
delete payload.challenge.name;
  this.submitProposal.emit({payload,selectedDmsFiles:this.selectedDmsFiles});
}

refreshForm() {
  this.challengeForm.reset();
  this.selectedDmsFiles = [];
  this.getDraftProposals();
}

stepSaveApiCall(){
  const payload={
      ...this.challengeForm?.value,
      title: this.challengeForm.get('name')?.value,
      nodal_officer_id:  this.challengeForm.get('nodal_officer_id')?.value?.id,
  }
  this.challengeForm.get('id')?.value ? payload.challenge_id = this.challengeForm.get('id')?.value : '';
  delete payload.proposal_id;
  delete payload.scheme;
  delete payload.name;
  this.apiService.putAPI(this.url+this.challengeForm.get('id')?.value+'/', payload).subscribe((res: any) => {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Challenge updated successfully.' });
    this.stepDetails.code === 'I-UPS' ? '': this.onStepCall()
  })
}

onCategoryChange(event: any) {
  console.log(event);
  if(event.value === 'To Fight') 
    this.challengeForm.get('organisation')?.setValue(24);
  else{
    this.challengeForm.get('organisation')?.setValue(8);
  }
}

getInitValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}

getPlaceValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}
getFunctionalValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}
getDomesticValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}
getImportValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}

getPreliminaryValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}

getGlobalValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}

getPotentialValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}


getRiskValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}

getPilotValue(placeholder:string): EditorComponent['init'] {
  return {
    ...this.init,
    placeholder: placeholder
  };
}


files:any[]=[]
getPushFiles(){
  this.files=[
    {name:"PDS", description:"PDS", type_document:".pdf",date:new Date().toISOString().substring(0, 10)},
    {name:"PRU", description:"PRU", type_document:".pdf",date:new Date().toISOString().substring(0, 10)},
    // {name:"NDA", description:"NDA", type_document:".pdf",date:new Date().toISOString().substring(0, 10)}
  ]
  
}

// Getter to check if both PDS and PRU files are uploaded
// get arePDSAndPRUUploaded(): boolean {
//   let filesToCheck: any[] = [];
  
//   if (this.uploadDocumentComponent && this.uploadDocumentComponent['documentsArray']) {
//     filesToCheck = this.uploadDocumentComponent['documentsArray'].controls
//       .map((control: any) => control.value)
//       .filter((val: any) => val && val.name);
//   } else {
//     filesToCheck = [...this.selectedDmsFiles];
//   }
  
//   let pdsFile: any = null;
//   let pruFile: any = null;
  
//   filesToCheck.forEach((file: any) => {
//     const fileName = (file.name || '').toUpperCase().trim();
//     const hasFile = file.file && (file.file instanceof File || file.file?.name || file.file || typeof file.file === 'string');
    
//     if (fileName === 'PDS' && hasFile) {
//       if (!pdsFile) {
//         pdsFile = file;
//       }
//     } else if (fileName === 'PRU' && hasFile) {
//       if (!pruFile) {
//         pruFile = file;
//       }
//     }
//   });
  
//   return !!(pdsFile && pruFile);
// }
 


}